import React from 'react';
import AnyCommentComponent from "./AnyCommentComponent";
import DataProcessing from './DataProcessing'
import LoginSocialList from './LoginSocialList'

class SendCommentGuest extends AnyCommentComponent {

    constructor(props) {
        super(props);

        this.state = {
            isAgreementAccepted: true,
        };
    }

    /**
     * Handle agreement checkbox change.
     *
     * @param e
     */
    handleAgreement = (e) => {
        this.setState({isAgreementAccepted: e.target.checked});
    };

    render() {
        const settings = this.getSettings();
        const translations = settings.i18;
        const inputs = settings.options.guestInputs;

        let elementInputs = [];

        inputs.forEach(el => {
            if (el === 'name') {
                elementInputs.push(
                    <div className="anycomment anycomment-input-list-single anycomment-input-list-single-name">
                        <label form="anycomment-author-name">{translations.name} <span
                            class="anycomment-label-import">*</span></label>
                        <input type="text" name="author_name" id="anycomment-author-name"
                               value={this.props.authorName}
                               required={true}
                               onChange={this.props.handleAuthorNameChange}
                        />
                    </div>);
            } else if (el === 'email') {
                elementInputs.push(
                    <div className="anycomment anycomment-input-list-single anycomment-input-list-single-email">
                        <label form="anycomment-author-email">{translations.email} <span
                            className="anycomment-label-import">*</span></label>
                        <input type="email" name="author_email" id="anycomment-author-email"
                               value={this.props.authorEmail}
                               required={true}
                               onChange={this.props.handleAuthorEmailChange}
                        />
                    </div>);
            } else if (el === 'website') {
                elementInputs.push(
                    <div className="anycomment anycomment-input-list-single anycomment-input-list-single-website">
                        <label form="anycomment-author-website">{translations.website}</label>
                        <input type="text" name="author_url" id="anycomment-author-website"
                               value={this.props.authorWebsite}
                               onChange={this.props.handleAuthorWebsiteChange}
                        />
                    </div>);
            }
        });

        const guestInputList = elementInputs.length ?
            <div className="anycomment anycomment-form-guest__container">
                <div className={"anycomment anycomment-input-list anycomment-input-list-" + elementInputs.length}>
                    {elementInputs}
                </div>
            </div> : '';

        return <div className="anycomment anycomment-form-guest">

            {settings.options.isFormTypeGuests || settings.options.isFormTypeAll ? guestInputList : ''}

            <div className="anycomment anycomment-form-guest__container">
                <div className="anycomment anycomment-form-guest-socials">
                    {(settings.options.isFormTypeSocials || settings.options.isFormTypeAll) && this.state.isAgreementAccepted ?
                        <LoginSocialList/> : ''}
                </div>
                <div className="anycomemnt anycomment-form-submit">
                    <DataProcessing isAgreementAccepted={this.props.isAgreementAccepted}
                                    onAccept={this.handleAgreement}/>
                    <input type="submit" disabled={!this.props.buttonEnabled}
                           className="anycomment-btn anycomment-send-comment-body__btn"
                           value={this.props.buttonText}/>
                </div>
            </div>
        </div>;
    }
}

export default SendCommentGuest;


// WEBPACK FOOTER //
// ./src/components/SendCommentGuest.js